import * as React from "react"
import * as Immutable from 'immutable'

import { SaleAdvert, SaleAdvertTranslation } from "../../../types/types";
import SimpleFormat from "../../../utils/SimpleFormat";
import SaleBooleanList from "./SaleBooleanList";
import { GeneralSaleBooleans, InteriorSaleBooleans, ActivitiesSaleBooleans } from "../../../advert_detail/booleans";
import { BooleansOf } from "../../../utils/types";

type Props = {
  advert: SaleAdvert
  translation: SaleAdvertTranslation
}


const DescriptionBooleans : () => Immutable.OrderedSet<BooleansOf<SaleAdvert>> = () => Immutable.OrderedSet(
  Immutable.Set(GeneralSaleBooleans()).merge(InteriorSaleBooleans()).merge(ActivitiesSaleBooleans())
)

export default (props: Props) : JSX.Element => (
  <>
    <h3>{I18n.t('sale_adverts.description.description')}</h3>
    <SimpleFormat
      text={!!props.translation ? props.translation.description : ''}
    />

    <h3>{I18n.t('sale_adverts.description.short')}</h3>
    <SimpleFormat
      text={!!props.translation ? props.translation.details : ''}
    />

    {
      props.advert.referenceNumber ?
        <>
          {I18n.t('activerecord.attributes.sale_advert.reference_number')}
          {' '}
          {props.advert.referenceNumber}
        </>
      : ''
    }
    <SaleBooleanList
      advert={props.advert}
      booleans={DescriptionBooleans().filter(x => props.advert[x]).toOrderedSet()}
    />
    <hr />
  </>
)
